import { useEffect } from "react";

const SignatoryNamesAtEnd = ({
  containerRef,
  signatories = [],
  label,
  dropX = 40,
  dropY = 100,
  signatureFields,
  setSignatureFields,
  setSelectedField,
  setModePayload,
}) => {
  useEffect(() => {
    if (!containerRef?.current || !signatories.length) return;

    const lastPageContainer = containerRef.current.lastElementChild;
    if (!lastPageContainer) return;

    const lastTextLayer = lastPageContainer.querySelector("div");
    if (!lastTextLayer) return;

    const newFields = [];

    signatories.forEach((signatory, idx) => {
      const fieldId = Date.now() + Math.random();

      const wrapper = document.createElement("div");
      wrapper.style.position = "absolute";
      wrapper.style.left = `${dropX}px`;
      wrapper.style.top = `${dropY + idx * 40}px`;
      wrapper.style.display = "flex";
      wrapper.style.alignItems = "center";
      wrapper.style.gap = "6px";
      wrapper.style.cursor = "move";

      // Name
      const nameDiv = document.createElement("div");
      nameDiv.innerText = signatory.name;
      nameDiv.style.fontWeight = "bold";

      // Field
      const field = document.createElement("div");
      field.innerText = label;
      field.contentEditable = true;
      field.style.padding = "4px 8px";
      field.style.border = "1px solid #666";
      field.style.backgroundColor = "#f9f9f9";
      field.style.borderRadius = "4px";
      field.style.fontSize = "14px";
      field.style.fontFamily = "Arial";
      field.style.color = "#000";

      // Icons
      const deleteIcon = document.createElement("span");
      deleteIcon.innerHTML = "❌";
      deleteIcon.style.cursor = "pointer";
      deleteIcon.title = "Delete Field";

      const editIcon = document.createElement("span");
      editIcon.innerHTML = "✏️";
      editIcon.style.cursor = "pointer";
      editIcon.title = "Edit Field";

      const saveIcon = document.createElement("span");
      saveIcon.innerHTML = "✅";
      saveIcon.style.cursor = "pointer";
      saveIcon.title = "Save Position";

      // ---------- Drag Logic ----------
      let isDragging = false;
      let offsetX = 0;
      let offsetY = 0;

      const onMouseMove = (e) => {
        if (!isDragging) return;

        const parentRect = lastTextLayer.getBoundingClientRect();
        const newX = e.clientX - parentRect.left - offsetX;
        const newY = e.clientY - parentRect.top - offsetY;

        wrapper.style.left = `${newX}px`;
        wrapper.style.top = `${newY}px`;
      };

      const onMouseUp = () => {
        isDragging = false;
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);

        const newX = parseFloat(wrapper.style.left);
        const newY = parseFloat(wrapper.style.top);

        setSignatureFields((prev) =>
          prev.map((f) => (f.id === fieldId ? { ...f, x: newX, y: newY } : f)),
        );
      };

      field.addEventListener("mousedown", (e) => {
        isDragging = true;
        const wrapperRect = wrapper.getBoundingClientRect();
        offsetX = e.clientX - wrapperRect.left;
        offsetY = e.clientY - wrapperRect.top;
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
        e.stopPropagation();
      });

      const onMouseDownHandler = (e) => {
        isDragging = true;
        const wrapperRect = wrapper.getBoundingClientRect();
        offsetX = e.clientX - wrapperRect.left;
        offsetY = e.clientY - wrapperRect.top;
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
        e.stopPropagation();
      };
      // ---------- Icon Actions ----------

      deleteIcon.onclick = () => {
        wrapper.remove();
        setSignatureFields((prev) => prev.filter((f) => f.id !== fieldId));
      };

      editIcon.onclick = () => {
        field.contentEditable = true;
        setSelectedField(field);
      };

      saveIcon.addEventListener("click", () => {
        field.contentEditable = false;
        wrapper.style.cursor = "default";

        const newX = parseFloat(wrapper.style.left);
        const newY = parseFloat(wrapper.style.top);

        setSignatureFields((prev) =>
          prev.map((f) =>
            f.id === fieldId // ✅ USE fieldId
              ? { ...f, x: newX, y: newY, saved: true }
              : f,
          ),
        );

        field.removeEventListener("mousedown", onMouseDownHandler);
      });

      // ---------- Append ----------
      wrapper.appendChild(nameDiv);
      wrapper.appendChild(field);
      wrapper.appendChild(deleteIcon);
      wrapper.appendChild(editIcon);
      wrapper.appendChild(saveIcon);
      lastTextLayer.appendChild(wrapper);

      // ---------- Store in State ----------
      const fieldData = {
        id: fieldId,
        label,
        signatoryName: signatory.name,
        x: dropX,
        y: dropY + idx * 40,
        pageIndex: containerRef.current.children.length - 1,
        saved: false,
      };

      newFields.push(fieldData);
    });

    setSignatureFields((prev) => [...prev, ...newFields]);
    if (setModePayload) setModePayload(null);
  }, [
    containerRef,
    signatories,
    label,
    dropX,
    dropY,
    setSignatureFields,
    setSelectedField,
    setModePayload,
  ]);

  return null;
};

export default SignatoryNamesAtEnd;
